export default function caseInvestigationManagerApi(fetch, baseUrl) {
  return {
    getAllCaseInvestigations(reqBody) {
      return fetch.post(`${baseUrl}/cases/search`, reqBody);
    },

    createNewCaseInvestigation(reqBody) {
      return fetch.post(`${baseUrl}/cases`, reqBody);
    },

    getCaseInvestigationDetails({ caseId }) {
      return fetch.get(`${baseUrl}/cases/by-id/${caseId}`);
    },

    addCaseInvestigationNoteInvestigationByCaseId({caseGuid, payload}) {
      return fetch.post(`${baseUrl}/cases/${caseGuid}/comments`, payload);
    },

    updateCaseInvestigationStatusByCaseId({caseGuid, status}) {
      return fetch.put(`${baseUrl}/admin/cases/${caseGuid}/status?status=${status}`);
    }

  };
}
